import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { ModuleType, ObjectTypes } from '@fi-shared/types';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { StatisticService } from '@fi-app/shared/statistic/statistic.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { IAccessRightFilterCollection } from '@fi-shared/models';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiTaskToCompleteTabsEnum } from '@fi-shared/fi-task-shared/fi-task-to-complete-tabs.enum';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-task-edit-container',
    template: `
        <div class="fi-container">
            <div class="fi-header Ccm-PageHeader">
                <span class="ccm-page-header-button-group">
                    <fi-button-back-new></fi-button-back-new>
                </span>
                <div class="Ccm-Header-Text" [textContent]="pageTitle"></div>
            </div>
            <div class="fi-content">
                <fi-task-edit
                    [task]="task"
                    [accessRightFilterCollection]="accessRightFilterCollection"
                    (saveCompleted)="onSaveCompleted()"
                ></fi-task-edit>
            </div>
        </div>
    `,
    styleUrls: ['./task-edit-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TaskEditContainerComponent implements OnInit {
    @Input() task: ITask;
    @Input() accessRightFilterCollection: IAccessRightFilterCollection;

    pageTitle: string;

    constructor(
        private objectTitleService: ObjectTitleService,
        private statisticService: StatisticService,
        private stateService: FiStateService,
        private pageTitleService: PageTitleService,
    ) {}

    ngOnInit(): void {
        this.statisticService.Visit(ModuleType.Task, ObjectTypes.Task, this.task.Id);
        this.pageTitle = this.objectTitleService.GetTitle(this.task.Id, this.task.Name, ObjectTypes.Task);

        // https://chainformation.atlassian.net/browse/FI-3805
        this.pageTitleService.setTitle(
            this.objectTitleService.getTitleForBrowserTab(this.task.Id, this.task.Name, ObjectTypes.Task),
        );
    }

    onSaveCompleted() {
        this.stateService.go(FiStateNames.Task.ToComplete, {
            tabNumber: FiTaskToCompleteTabsEnum.AssignedByMe,
        });
    }
}
